import React from 'react';

import styled from '@emotion/styled';
import FilterBtn from '../atoms/filterBtn';
import icon01 from '../../assets/imgs/icon-btn-01.svg';
import icon02 from '../../assets/imgs/icon-btn-02.svg';
import icon03 from '../../assets/imgs/icon-btn-03.svg';
import icon04 from '../../assets/imgs/icon-btn-04.svg';
import icon05 from '../../assets/imgs/icon-btn-05.svg';
import icon06 from '../../assets/imgs/icon-btn-06.svg';
import iconActive01 from '../../assets/imgs/icon-btn-active-01.svg';
import iconActive02 from '../../assets/imgs/icon-btn-active-02.svg';
import iconActive03 from '../../assets/imgs/icon-btn-active-03.svg';
import iconActive04 from '../../assets/imgs/icon-btn-active-04.svg';
import iconActive05 from '../../assets/imgs/icon-btn-active-05.svg';
import iconActive06 from '../../assets/imgs/icon-btn-active-06.svg';
import BtnRow from '../molecules/btnRow';
import { mq, gray01 } from '../../_style';
import Br from '../atoms/br';
import ShowAllBtn from '../atoms/showAllBtn';

export const BtnData = [
  [
    {
      value: 'badbreath',
      category: '口臭・汚れ・ネバつき 予防',
      label: (
        <>
          口臭・汚れ・<Br onlySp></Br>ネバつき<Br onlyPc></Br>予防
        </>
      ),
      icon: icon01,
      iconActive: iconActive01,

    },
    {
      value: 'periodontaldisease',
      category: '歯周病・歯肉炎 予防',
      label: (
        <>
          歯周病・歯肉炎 <Br onlyPc></Br>予防
        </>
      ),
      icon: icon03,
      iconActive: iconActive03,
    },
    {
      value: 'cavity',
      category: 'むし歯予防',
      label: <>むし歯予防</>,
      icon: icon02,
      iconActive: iconActive02,
    },
    {
      value: 'whitening',
      category: 'ホワイトニング',
      label: <>ホワイトニング</>,
      icon: icon04,
      iconActive: iconActive04,
    },
    {
      value: 'multicare',
      category: 'マルチケア',
      label: <>マルチケア</>,
      icon: icon05,
      iconActive: iconActive05,
    },
    {
      value: 'sterilize',
      category: '殺菌',
      label: <>殺菌</>,
      icon: icon06,
      iconActive: iconActive06,
    },
  ],
  [
    {
      value: 'alcohol',
      category: 'アルコール配合',
      label: <>アルコール<Br onlySp></Br>配合</>,
    },
    {
      value: 'nonalcoholic',
      category: 'ノンアルコール',
      label: <>ノンアルコール</>,
    },
  ],
  [
    {
      value: 'regular',
      category: 'レギュラー',
      label: <>レギュラー</>,
    },
    {
      value: 'premiumcare',
      category: 'プレミアムケア',
      label: <>プレミアムケア</>,
    },
    {
      value: 'specialtycare',
      category: '専用ケア',
      label: <>専用ケア</>,
    },
    {
      value: 'forkids',
      category: '子ども用',
      label: <>子ども用</>,
    },
    {
      value: 'dispenser',
      category: '自動ディスペンサー',
      label: <>自動<Br onlySp></Br>ディスペンサー</>,
    }
  ]
];

const Container = styled.div`
  background-color: ${gray01};
  padding: 52px;
  text-align: center;
  ${mq.pc} {
    margin: auto;
    max-width: 1064px;
  }
  ${mq.sp} {
    padding: 42px 20px;
  }
  & > a, & > button {
    display: inline-flex;
    margin-top: 52px;
  }
`;

const Inner = styled.div`
  margin-top: 52px;
  ${mq.pc} {
    display: flex;
  }
  ${mq.sp} {
    & > * {
      & + * {
        margin-top: 52px;
      }
    }
  }
`

export default class BtnGroup extends React.Component {
  render() {
    return (
      <Container>
        <BtnRow label={'効果・目的で探す'}>
          {BtnData[0].map((item, index) => {
            return (
              <FilterBtn
                key={index}
                value={item.value}
                categoryName={item.category}
                fun={this.props.fun ? this.props.fun : null}
                name={'category'}
                query={this.props.query ? this.props.query : null}
                to={
                  !this.props.isRadio ? `/lineup?category=${item.value}` : null
                }
                icon={item.icon}
                iconActive={item.iconActive}
                isRadio={this.props.isRadio}
              >
                {item.label}
              </FilterBtn>
            );
          })}
        </BtnRow>
        <Inner>
          <BtnRow label={'アルコールの有無で探す'} col={1}>
            {BtnData[1].map((item, index) => {
              return (
                <FilterBtn
                  key={index}
                  value={item.value}
                  categoryName={item.category}
                  fun={this.props.fun ? this.props.fun : null}
                  name={'category'}
                  query={this.props.query ? this.props.query : null}
                  to={
                    !this.props.isRadio ? `/lineup?category=${item.value}` : null
                  }
                  isRadio={this.props.isRadio}
                >
                  {item.label}
                </FilterBtn>
              );
            })}
          </BtnRow>
          <BtnRow label={'製品タイプで探す'} col={3}>
            {BtnData[2].map((item, index) => {
              return (
                <FilterBtn
                  key={index}
                  value={item.value}
                  categoryName={item.category}
                  fun={this.props.fun ? this.props.fun : null}
                  name={'category'}
                  query={this.props.query ? this.props.query : null}
                  to={
                    !this.props.isRadio ? `/lineup?category=${item.value}` : null
                  }
                  isRadio={this.props.isRadio}
                >
                  {item.label}
                </FilterBtn>
              );
            })}
          </BtnRow>
        </Inner>
        {!this.props.fun ? <ShowAllBtn to={'/lineup'}></ShowAllBtn> : <ShowAllBtn fun={this.props.fun}></ShowAllBtn>}
      </Container>
    );
  }
}
